import { getJSON, setJSON } from './storage.js';

const PWA_KEY = 'gsorg_pwa_prompt';

export function isStandalone() {
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    window.navigator.standalone === true ||
    document.referrer.includes('android-app://')
  );
}

export function getPwaState() {
  return getJSON(PWA_KEY, { dismissed: false, installed: false });
}

export function setPwaDismissed() {
  setJSON(PWA_KEY, { ...getPwaState(), dismissed: true, dismissedAt: Date.now() });
}

export function setPwaInstalled() {
  setJSON(PWA_KEY, { dismissed: true, installed: true, installedAt: Date.now() });
}

export function shouldShowPwaPrompt() {
  if (isStandalone()) return false;
  const state = getPwaState();
  if (state.installed || state.dismissed) return false;
  return true;
}

export function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) return Promise.resolve(null);
  // Only register in production / preview (or always when not pure file://)
  if (location.protocol === 'file:') return Promise.resolve(null);
  return navigator.serviceWorker
    .register('/sw.js')
    .then((reg) => reg)
    .catch((err) => {
      console.warn('SW register failed', err);
      return null;
    });
}

let deferredPrompt = null;

export function captureInstallPrompt() {
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    deferredPrompt = e;
    window.dispatchEvent(new CustomEvent('gsorg:installable'));
  });
  window.addEventListener('appinstalled', () => {
    deferredPrompt = null;
    setPwaInstalled();
    window.dispatchEvent(new CustomEvent('gsorg:installed'));
  });
}

export function getDeferredPrompt() {
  return deferredPrompt;
}

export async function promptInstall() {
  if (!deferredPrompt) return { outcome: 'unavailable' };
  deferredPrompt.prompt();
  const choice = await deferredPrompt.userChoice;
  deferredPrompt = null;
  if (choice.outcome === 'accepted') setPwaInstalled();
  return choice;
}

export function isIos() {
  return /iphone|ipad|ipod/i.test(navigator.userAgent);
}
